import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, first } from 'rxjs';
import { DeviceIdService } from './device-id-service/device-id.service';
import { UserState } from 'src/app/models/class/user.state';
import { User } from 'src/app/models/interfaces/user.model';
import { SessionState } from 'src/app/models/class/session.state';
import { Session } from 'src/app/models/interfaces/session.model';
import { RegisterStageState } from 'src/app/models/class/register-stage.state';
import { RegisterStage } from 'src/app/models/interfaces/register-stage.model';
import { LocalStorageEnum } from 'src/app/models/enum/local-storage.enum';

@Injectable({
  providedIn: 'root'
})
export class DeviceStoreService {
  
  readonly _deviceId = new ReplaySubject<string>(1);
  readonly _user = new UserState();
  readonly _session = new SessionState();
  readonly _registerStage = new RegisterStageState();
  readonly _isSignedOn = new ReplaySubject<boolean>(1);

  constructor(private deviceIdService: DeviceIdService) 
  {
    this.deviceIdService.getDeviceID().then((id: string) => this._deviceId.next(id));

    this._isSignedOn.next(false);

    if(localStorage.getItem(LocalStorageEnum.CAN_DEL_DRIVER))
    {
      this.setSession({
        canDeleteDriver: JSON.parse(localStorage.getItem(LocalStorageEnum.CAN_DEL_DRIVER) as string) === true
      });
    }
  }

  get deviceId(): Observable<string>
  {
    return this._deviceId.asObservable().pipe(first());
  }

  get user(): Observable<User>
  {
    return this._user.getValue().id !== 0 ? this._user.asObservable() : this.getUserFromLocalStorage();
  }

  get registerStage(): Observable<RegisterStage>
  {
    return this._registerStage.asObservable();
  }

  setSession(session: Partial<Session>)
  {
    this._session.next(session);
  }

  setUser(user: Partial<User>)
  {
    this._user.next(user);
    
    localStorage.setItem(LocalStorageEnum.USER, JSON.stringify(user));
  }

  setIsSignedOn(isSignedOnBool: boolean)
  {
    this._isSignedOn.next(isSignedOnBool);
  }

  getUserFromLocalStorage(): Observable<User>
  {
    const user = JSON.parse((localStorage.getItem(LocalStorageEnum.USER) as string));

    this._user.next(user);

    return this._user.asObservable();
  }

  getSession(): Observable<Session>
  {
    return this._session.asObservable();
  }

  getIsSignedOn(): Observable<boolean>
  {
    return this._isSignedOn.asObservable();
  }

  setRegisterStage(registerStage: Partial<RegisterStage>)
  {
    this._registerStage.next(registerStage);
  }

}
